// Use month precision for both dated archive entries and newsletter issues.
export default function formatNewsDate(value, lang = "de") {
  if (!value) return "";
  const text = String(value).trim();
  const iso = text.match(/^(\d{4})-(\d{2})(?:-\d{2})?$/);
  const issue = text.match(/^(\d{1,2})\/(\d{4})$/);
  if (!iso && !issue) return text;

  const year = Number(iso ? iso[1] : issue[2]);
  const month = Number(iso ? iso[2] : issue[1]);
  if (month < 1 || month > 12) return text;

  return new Intl.DateTimeFormat(lang === "de" ? "de-DE" : "en-GB", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(year, month - 1, 1)));
}
